import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteError, RouteNotFound } from "@/components/route-boundaries";

export const Route = createFileRoute("/_authenticated/admin/bousala/attempts")({
  head: () => ({ meta: [{ title: "محاولات بوصلة د. سارة" }, { name: "robots", content: "noindex" }] }),
  errorComponent: RouteError,
  notFoundComponent: RouteNotFound,
  component: () => <Outlet />,
});